import { Tooltip } from "@mui/material";
import { CordovaFileDetail, ElectronFileDetail, materialsData } from "../../utils/interface";
import './ImageViewer.scss';
import { useCallback, useEffect, useRef, useState } from "react";
import { getScreenDimensions } from "../../utils/helper";
import MobileHeader from "../MobileHeader/MobileHeader";

interface ImageViewerProps {
    file: string;
    imgFileData?: materialsData|undefined|ElectronFileDetail | null | CordovaFileDetail;
    onClose: () => void;
    type : string;
}

const ImageViewer:React.FC<ImageViewerProps> = ({ file, imgFileData, onClose, type}) =>{
    const textRef = useRef<HTMLDivElement>(null);
    const [isEllipsisActive, setIsEllipsisActive] = useState(false);
  
    // Function to check if text is truncated
    const checkEllipsis = useCallback(() => {
      if (textRef.current) {
        setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    }, []);
  
    useEffect(() => {
      checkEllipsis(); // Check on mount
      window.addEventListener("resize", checkEllipsis); // Recheck on resize
  
      return () => window.removeEventListener("resize", checkEllipsis); // Cleanup on unmount
    }, [checkEllipsis, imgFileData?.filename]);
    return(
       <div className="ImageViewerCtn">
       { getScreenDimensions().isMobileScreen &&   type!=='chat' &&<div className="images-header">
        <div className="images-header-name">Images</div>
        <div><MobileHeader/></div>
        </div>}
         {getScreenDimensions().isMobileScreen &&  type!=='chat' && <div className="ImgeFileNameCtn">
            <Tooltip title={isEllipsisActive ? imgFileData?.filename : ""}>
      <div ref={textRef} className="ImgeFileName">
        {imgFileData?.filename}
      </div>
    </Tooltip>
        </div>}
         <div className="ImageCtn">
         <img src={file} alt="ImageMaterial" className="ImageMaterialImg"/>
         </div>
         {!getScreenDimensions().isMobileScreen &&  type!=='chat' && <div className="ImgeFileNameCtn">
            <Tooltip title={isEllipsisActive ? imgFileData?.filename : ""}>
      <div ref={textRef} className="ImgeFileName">
        {imgFileData?.filename}
      </div>
    </Tooltip>
        </div>}
       </div>
    )
}

export default ImageViewer;
